import React, { Component } from 'react';
import Answer from '../components/Answer';

class AnswerContainer extends Component{

    render(){
        var currentQuestionIndex = this.props.questionIndex;
        var currentAnswerSelected= this.props.handleAnswerSelected;
        var currentEnabled = this.props.enabled;
        var currentSelected = this.props.currentAnswer;
        return(
            <ul className="isg_answer_container">
            {this.props.answerList.map(function(answer, index){
                return (
                    <Answer
                        key={index}
                        answer={answer.answer}
                        index={index}
                        questionIndex={currentQuestionIndex}
                        handleAnswerSelected={currentAnswerSelected}
                        enabled={currentEnabled}
                        selected={currentSelected === index}
                    />
                );
            })}
            </ul>
        );
    }
}

AnswerContainer.propTypes = {
    answerList: React.PropTypes.array.isRequired,
    questionIndex: React.PropTypes.number.isRequired,
    handleAnswerSelected: React.PropTypes.func.isRequired,
    enabled: React.PropTypes.bool.isRequired,
    currentAnswer: React.PropTypes.number
};

export default AnswerContainer;


/** WEBPACK FOOTER **
 ** ./src/components/AnswerContainer.js
 **/